import { Controller } from "@hotwired/stimulus"

// Phase strip on the event page. Non-pending cards are links that open their
// phase ranking in the `event_ranking` turbo frame; this controller just paints
// the clicked card as selected for instant feedback (the frame swap shows the
// actual ranking). The current (live) phase starts selected server-side (see
// the view) so the highlight survives before/without this controller mounting.
export default class extends Controller {
  // Mount signal: lets a system test wait for the controller to be wired before
  // clicking a card, instead of racing the Stimulus mount (#596, see #461).
  connect() {
    this.element.dataset.connected = "true"
  }

  select(event) {
    this.element
      .querySelectorAll(".event-phase--selected")
      .forEach((el) => el.classList.remove("event-phase--selected"))
    event.currentTarget.classList.add("event-phase--selected")
  }
}
